// components/Map/index.tsx (the public interface)
'use client'

import dynamic from 'next/dynamic'
import React from 'react'

const MapComponent = dynamic(() => import('./Map'), {
  ssr: false,
  loading: () => (
    <div 
      className="w-full h-full absolute inset-0 animate-pulse"
      style={{ backgroundColor: '#80deea' }}
    />
  ),
})

export interface MapProps {
  interactive?: boolean
  children: React.ReactNode
  initialViewState: {
    longitude: number
    latitude: number
    zoom: number
  }
}

export default MapComponent